<res-base-modal [modalTitle]="entityData.title" [modalAutomationId]="modalAutomationId" [primaryButtonLabel]="'OK'"
    (primaryButtonActionEmt)="ok()" (closeButtonActionEmt)="closeModal()" [secondaryButtonLabel]="'Cancel'"
    [isPrimaryBtnEnabled]="okEnabled()" [(isBusy)]="isBusy" [(isBusyMessage)]="isBusyMessage"
    [verifyRequiredValidator]="true" [modalClass]="modalClass" [modalHelpIndex]="entityData.helpIndex">

    <res-name-description [name]="entityData.name" [description]="entityData.description"
        [entityType]="entityData.entityType" [validateNameRequest]="entityData.validateNameRequest"
        [validateName]="entityData.validateName" [automationId]="modalAutomationId" [isNameDisabled]="isNameDisabled">
    </res-name-description>

    <div class="modal-row">
        <div class="modal-row-column-auto group-label">
            <label requiredAsterisk for="role">Role:
            </label>
        </div>
        <div class="modal-row-column-max description">
            <select name="selectedRole" class="modal-row-column-auto selected-role"
                [(ngModel)]="entityData.selectedRole">
                <option *ngFor="let role of roleList" [value]="role.name" [hidden]="hideRoleOption(role)"> {{role.name}}
                </option>
            </select>
        </div>
    </div>
</res-base-modal>